import _ from 'lodash';
import { Commit, Dispatch } from 'vuex';

import { RESET } from '../listEditTypes';
import {
	PAGE_MGR_BACK_TO, PAGE_MGR_LOAD, PAGE_MGR_CLEAR,
	PAGE_MGR_REMOVE_TO, PGE_MGR_REMOVE_PAGES, REFRESH_PREVIOUS,
} from '../actionTypes';
import { PageManager } from './state';

export const actions = {
	[PAGE_MGR_REMOVE_TO]: ({ commit, state }: { commit: Commit, state: PageManager }, { toPath }: { toPath: string }) => {
		const index = _(state.pages).findIndex((item) => item.path === toPath);
		const pagesToRemove = (index === -1) ? state.pages : state.pages.slice((index + 1) - state.pages.length);

		pagesToRemove.forEach(({ storeModule, storeObject }) => {
			if (storeModule && storeObject) {
				commit(RESET, { storeModule, storeObject }, { root: true });
			}
		});
		commit(PGE_MGR_REMOVE_PAGES, { index: index + 1 });
		return pagesToRemove.filter((page) => !page.storeObject);
	},

	async [PAGE_MGR_BACK_TO](
		{ commit, state, dispatch }: { commit: Commit, dispatch: Dispatch, state: PageManager },
		{ path, refreshPreviousPage, replace }: { path: string, refreshPreviousPage: boolean, replace: boolean },
	) {
		if (!state.pages[state.pages.length - 1]) { return null; }
		const toPath = (replace) ? state.pages[state.pages.length - 2].path : path;

		const modulesForRemove = await dispatch(PAGE_MGR_REMOVE_TO, { toPath });
		commit(REFRESH_PREVIOUS, refreshPreviousPage);

		return Promise.resolve(modulesForRemove);
	},

	[PAGE_MGR_LOAD]: (
		{ commit, state }: { commit: Commit, state: PageManager },
		{ name, path, loadFunction, refreshFun, storeModule, storeObject, id, props }: {
			name: string,
			path: string,
			loadFunction: () => any,
			refreshFun: () => any,
			storeModule: string | null,
			storeObject: string | null,
			id: number | null,
			props: object,
		},
	) => {
		const page = state.pages.find((i) => i.path === path);
		if (page) {
			page.refresh && refreshFun && refreshFun();
			page.refresh = false;
			if (!page.loadData) return;
		}
		commit(PAGE_MGR_LOAD, {
			name, path, storeModule, storeObject, id, props,
		});
		loadFunction();
	},
	[PAGE_MGR_CLEAR]: ({ commit }: { commit: Commit }) => {
		commit(PAGE_MGR_CLEAR);
	},
};
